import axios from 'axios'
import router from '@/router'
import { authUtils } from '@/utils/auth'
import { Message } from 'element-ui'

// API基础URL
// export const API_BASE_URL = 'http://192.168.2.102:10111/api'//dev 
export const API_BASE_URL = '/api'//prod

// 创建axios实例
const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true  // 重要：允许携带Cookie，确保Session一致
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    const authHeader = authUtils.getAuthHeader()
    if (authHeader.Authorization) {
      config.headers['Authorization'] = authHeader.Authorization
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 是否正在处理token失效（防止重复提示）
let isHandlingTokenExpired = false

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 检查响应数据中的code
    const { data } = response
    if (data && data.code === 401) {
      handleTokenExpired()
      return Promise.reject(new Error(data.msg || 'Token失效'))
    }
    if (data && data.code === 403) {
      Message.error(data.msg || '权限不足，无法访问该资源')
      router.replace('/')
      return Promise.reject(new Error(data.msg || '权限不足'))
    }
    return response
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理401/403错误
    if (error.response) {
      const status = error.response.status
      const data = error.response.data
      
      // 401: 未授权（token失效、token无效等）
      if (status === 401 || (data && data.code === 401)) {
        handleTokenExpired()
        return Promise.reject(error)
      }
      
      // 403: 禁止访问（权限不足）
      if (status === 403 || (data && data.code === 403)) {
        Message.error((data && data.msg) ? data.msg : '权限不足，无法执行该操作')
        router.replace('/')
        return Promise.reject(error)
      }
    }
    
    return Promise.reject(error)
  }
)

/**
 * 处理token失效
 */
function handleTokenExpired() {
  // 防止重复处理
  if (isHandlingTokenExpired) {
    return
  }
  isHandlingTokenExpired = true
  
  // 显示提示信息
  Message.warning({
    message: '登录已过期，请重新登录',
    duration: 2000,
    onClose: () => {
      // 清除所有认证信息
      authUtils.clearAuth()
      
      // 跳转到登录页
      const currentPath = router.currentRoute.fullPath
      if (currentPath !== '/login') {
        router.push({
          path: '/login',
          query: { redirect: currentPath } // 保存当前路径，登录后可跳转回来
        })
      }
      
      // 重置标志
      setTimeout(() => {
        isHandlingTokenExpired = false
      }, 1000)
    }
  })
}

export default service

